import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewChild,
  OnInit,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormArray,
  FormControl,
} from '@angular/forms';
import { CurrentUserService } from '../../../core/services/user/current-user.service';
import { GenderUtils } from '../../../utils/gender-utils';
import {
  ComplaintsListModel,
  ReasonsListModel,
} from '../../../core/models/consultation/medical-information-list.model';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../../core/services/toast.service';
import { dateFormatValidator } from '../../validators/birth-date-validator.validator';
import { PatientInformationFormComponent } from '../../components/patient-information-form/patient-information-form.component';
import { HabitsFormComponent } from '../../components/habits-form/habits-form.component';
import { GoalsFormComponent } from '../../components/goals-form/goals-form.component';
import { DiseaseInformationFormComponent } from '../../components/disease-information-form/disease-information-form.component';
import { PATIENT_TABS } from '../../constants/patient-tabs';
import { WarningPreferenceType } from '../../../../enums/warning-preference.enum';
import { OverlayService } from '../../../core/services/overlay.service';
import { Router } from '@angular/router';
import { TimePeriod } from '../../../../enums/time-period.enum';
import { ConsultationsService } from '../../../core/services/consultation/consultations.service';
import { PatientsService } from '../../../core/services/patient/patients.service';
import { OTHER_MEDICATIONS_OTHERS } from '../../constants/other-medications';
import { SurveyService } from '../../../core/services/survey/survey.service';
import {
  Survey,
  SurveyQuestion,
} from '../../../core/models/survey/survey.model';
import { SURVEY_TYPES } from '../../constants/survey-types';
import { FullscreenService } from '../../../core/services/fullscreen.service';
import { lettersOnlyValidator, optionalMinLength, optionalPattern, validateAtLeastOneMethodSelectedPerType } from '../../shared/validators/validators';
import { PatientInformationCard } from '../../../core/models/patient/case-card-information.model';
import { DateFormatterUtil } from '../../../utils/date-format-utils';
import { UserSessionModel } from '../../../core/models/user/current-user.model';
import { UsersService } from '../../../core/services/user/users.service';
import { CaseSettingFormComponent } from '../case-setting-form/case-setting-form.component';
import { SummaryFormComponent } from '../summary-form/summary-form.component';
@Component({
  selector: 'app-diabetes-forms',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectDropDownModule,
    TranslateModule,
    PatientInformationFormComponent,
    HabitsFormComponent,
    GoalsFormComponent,
    DiseaseInformationFormComponent,
    CaseSettingFormComponent,
    SummaryFormComponent
  ],
  templateUrl: './diabetes-forms.component.html',
  styleUrl: './diabetes-forms.component.scss',
})
export class DiabetesFormsComponent implements AfterViewInit, OnInit {
  @Input() newPatientId: string = '';
  @Input() caseId: string = '';
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild(GoalsFormComponent) goalsFormComponent!: GoalsFormComponent;
  patientTabs = PATIENT_TABS;
  medicationConfig: any = {
    displayKey: 'name',
    valueKey: 'id',
    search: true,
    height: '200px',
    placeholder: this.translate.instant('selectMedication'),
    limitTo: 0,
    moreText: 'more',
  };

  newPatientInformationForm: FormGroup;
  habitsForm: FormGroup;
  goalsForm: FormGroup;
  diseasesInformationForm: FormGroup;
  caseSettingForm: FormGroup;


  currentUser: UserSessionModel | null = null;
  genders = GenderUtils.getAllGenders();
  medications: ComplaintsListModel[] = [];
  reasons: ReasonsListModel[] = [];
  isOverlayLoading: boolean = false;
  isBtnEnabled: boolean = true;
  selectedImageIndex: number | null = null;
  takeImageAgainBtn: boolean = true;
  selectedImage: any = null;
  isDragOver: boolean = false;
  uploadedFile: string | ArrayBuffer | null = null;
  isUploading: boolean = false;
  uploadFileName: string = '';
  maxDate: string = '';
  minDate: string = '';
  bmi: number | null = null;
  diabetDiagnosisTypes: { id: string; text: string; value: boolean }[] = [
    {
      id: 'hasDiabetesYes',
      text: this.translate.instant('yes'),
      value: true,
    },
    {
      id: 'hasDiabetesNo',
      text: this.translate.instant('no'),
      value: false,
    },
  ];
  medicationForDiabetes: { id: string; text: string; value: string }[] = [
    {
      id: 'oralHypoglycemic',
      text: 'oralHypoglycemic',
      value: 'oralHypoglycemic',
    },
    { id: 'insulin', text: 'insulin', value: 'insulin' },
    { id: 'none', text: 'none', value: 'none' },
  ];
  insulinAdministrationRouteArr = [
    { id: 'injection', text: this.translate.instant('injection') },
    { id: 'pump', text: this.translate.instant('pump') },
  ];
  times: { id: string; text: string; value: number }[] = [
    { id: 'morning', text: this.translate.instant('morning'), value: 1 },
    { id: 'noon', text: this.translate.instant('noon'), value: 2 },
    { id: 'evening', text: this.translate.instant('evening'), value: 3 },
    { id: 'other', text: this.translate.instant('other'), value: 4 },
  ];
  insulinTableHeaders = [
    { id: 'time', text: this.translate.instant('time') },
    { id: 'selected', text: this.translate.instant('selected') },
    { id: 'insulinType', text: this.translate.instant('insulinType') },
    { id: 'doseIU', text: this.translate.instant('doseIU') },
    { id: 'time', text: this.translate.instant('time') },
  ];
  insulinTypes: { id: string; name: string }[] = [];
  omedicationTypes: { id: string; name: string }[] = [];
  oralHypoglycemicTableHeaders = [
    { id: 'time', text: this.translate.instant('time') },
    { id: 'selected', text: this.translate.instant('selected') },
    { id: 'medicineName', text: this.translate.instant('medicineName') },
    { id: 'doseIU', text: this.translate.instant('doseIU') },
    { id: 'time', text: this.translate.instant('time') },
  ];
  surveys: Survey[] = [];
  habitsSurvey: Survey | null = null;
  goalsSurvey: Survey | null = null;
  private latestCaseDetail: any | null = null;

  constructor(
    private ch: ChangeDetectorRef,
    private currentUserService: CurrentUserService,
    private fullscreenService: FullscreenService,
    private fb: FormBuilder,
    private toastService: ToastService,
    private overlayService: OverlayService,
    private router: Router,
    private translate: TranslateService,
    private consultationsService: ConsultationsService,
    private patientsService: PatientsService,
    private surveyService: SurveyService,
    private userService: UsersService
  ) {
    this.translate.setDefaultLang('tr');
    this.translate.use('tr');

    this.newPatientInformationForm = this.fb.group({
      tckn: ['', [Validators.required, Validators.minLength(11)]],
      name: ['', [Validators.required, lettersOnlyValidator()]],
      lastName: ['', [Validators.required, lettersOnlyValidator()]],
      gender: [null, Validators.required],
      birthDate: ['', [Validators.required, dateFormatValidator()]],
      email: ['', [Validators.required, Validators.email]],
      phone1: [
        '',
        [
          Validators.required,
          Validators.minLength(13),
          Validators.maxLength(13),
          Validators.pattern('^\\+?[0-9]{7,15}$'),
        ],
      ],
      patientRelatives: this.fb.array([
        this.fb.group({
          nextOfKinEmailAddress: ['', [Validators.required, Validators.email]],
          nextOfKinMobilePhoneNumber: [
            '',
            [
              Validators.required,
              Validators.minLength(13),
              Validators.maxLength(13),
              Validators.pattern('^\\+?[0-9]{7,15}$'),
            ],
          ],
        }),
        this.fb.group({
          nextOfKinEmailAddress: ['', [Validators.email]],
          nextOfKinMobilePhoneNumber: [
            '',
            [
              // optionalMinLength(13),
              optionalPattern('^\\+?[0-9]{7,15}$'),
              
            ],
          ],
        }),
      ]),
      doctorMobilePhoneNumber: [
        '',
        [
          Validators.required,
          Validators.minLength(13),
          Validators.maxLength(13),
          Validators.pattern('^\\+?[0-9]{7,15}$'),
        ],
      ],
      doctorEmailAddress: ['', [Validators.required, Validators.email]],
      height: [null, [Validators.required, Validators.max(300)]],
      weight: [null, [Validators.required, Validators.max(999)]],

      bmi: [null],
      ecgFile: [null],
    });
    this.habitsForm = this.fb.group({
      healthyEating: [0, Validators.required],
      takeMedications: [0, Validators.required],
      monitorDisease: [0, Validators.required],
      active: [0, Validators.required],
      stressLevel: [0, Validators.required],
      hypoglycemicAttacks: [0, Validators.required],
      lowSodium: [0, Validators.required],
      exercise: [0, Validators.required],
      exerciseDuration: [0, Validators.required],
    });
    this.diseasesInformationForm = this.fb.group({
      hasDiabetes: [null, Validators.required],
      diabetesTypeId: [null],
      diagnosisDate: [null],
      diagnosisDateView: [null],
      medicationType: [null],
      oralHypoglycemic: [false],
      insulin: [false],
      none: [false],
      medications: [null],
      hasHeartDisease: [false],
      hasKidneyDisease: [false],
      hasThyroidDisease: [false],

      // Oral Hypoglycemic
      morningOralHypoglycemicSelected: [null],
      morningOralHypoglycemicMedicineName: [null],
      morningOralHypoglycemicDose: [null],
      morningOralHypoglycemicTime: [null],
      noonOralHypoglycemicSelected: [null],
      noonOralHypoglycemicMedicineName: [null],
      noonOralHypoglycemicDose: [null],
      noonOralHypoglycemicTime: [null],
      eveningOralHypoglycemicSelected: [null],
      eveningOralHypoglycemicMedicineName: [null],
      eveningOralHypoglycemicDose: [null],
      eveningOralHypoglycemicTime: [null],

      // Insulin
      insulinAdministrationMethod: [null],
      morningInsulinSelected: [null],
      morningInsulinNPH: [false],
      morningInsulinLente: [false],
      morningInsulinUltralente: [false],
      morningInsulinDose: [null],
      morningInsulinTime: [null],
      noonInsulinSelected: [null],
      noonInsulinNPH: [false],
      noonInsulinLente: [false],
      noonInsulinUltralente: [false],
      noonInsulinDose: [null],
      noonInsulinTime: [null],
      eveningInsulinSelected: [null],
      eveningInsulinNPH: [false],
      eveningInsulinLente: [false],
      eveningInsulinUltralente: [false],
      eveningInsulinDose: [null],
      eveningInsulinTime: [null],

      // Lab Information fields
      testDate: [null],
      timeOfDay: [null],
      hbA1cValue: [null],
      targetLowerLimit: [null],
      targetUpperLimit: [null],

      // Other Chronic Diseases
      hypertension: [false],
      cardiovascularDisease: [false],
      heartFailure: [false],
      hyperlipidemia: [false],
      kidneyFailure: [false],
      chronicPain: [false],
      majorDepression: [false],
      anxiety: [false],
      sleepDisorder: [false],
      physicalDisability: [false],
      other: [false],

      // Other Medications
      otherMed_morningSelected: [false],
      otherMed_morningName: [null],
      otherMed_morningDose: [null],
      otherMed_morningTime: [null],
      otherMed_noonSelected: [false],
      otherMed_noonName: [null],
      otherMed_noonDose: [null],
      otherMed_noonTime: [null],
      otherMed_eveningSelected: [false],
      otherMed_eveningName: [null],
      otherMed_eveningDose: [null],
      otherMed_eveningTime: [null],
      otherMed_otherSelected: [false],
      otherMed_otherName: [null],
      otherMed_otherDose: [null],
      otherMed_otherTime: [null],
      otherMed_morningOtherMedication: [null],
      otherMed_noonOtherMedication: [null],
      otherMed_eveningOtherMedication: [null],
      otherMed_otherOtherMedication: [null],
    });
    this.caseSettingForm = this.fb.group({
      hypoglycemiaThreshold: [40, [Validators.required, Validators.min(0)]],
      fastingGlucoseThreshold: [110, [Validators.required, Validators.min(0)]],
      postprandialGlucoseThreshold: [150, [Validators.required, Validators.min(0)]],
      hba1cThreshold: [null, [Validators.required, Validators.min(0), Validators.max(100)]],
      followUpDurationDays: [14, [Validators.required, Validators.min(1), Validators.max(365)]],
      disableNotificationsAfterFollowUp: [false], // checkbox için varsayılan false, zorunlu değil
    });

  }

  ngOnInit(): void {
    this.currentUser = this.currentUserService.GetSession();
    this.loadSurveys();
    this.initializeForms();
    this.getMedicalInformationsList();
    this.getPatientCaseCardInformation();
    this.getPatientRecordCaseDetail();


    var notificationTypes: { id: string; label: string }[] = [
      { id: 'lowBloodSugar', label: this.translate.instant('lowBloodSugar') },
      {
        id: 'noGlucoseMeasurement',
        label: this.translate.instant('noGlucoseMeasurement'),
      },
      {
        id: 'noSurveyData',
        label: this.translate.instant('noSurveyData'),
      },
    ];
    var notificationMethods: { id: string; label: string }[] = [
      { id: 'doctorSms', label: this.translate.instant('doctorSms') },
      { id: 'doctorEmail', label: this.translate.instant('doctorEmailNotice') },
      { id: 'nextOfKinSms', label: this.translate.instant('nextOfKinSms') },
      { id: 'nextOfKinEmail', label: this.translate.instant('nextOfKinEmail') },
    ];

    notificationTypes.forEach(type => {
      notificationMethods.forEach(method => {
        const key = `notification_${type.id}_${method.id}`;
        this.newPatientInformationForm.addControl(key, new FormControl(false));
      });
    });
    // doctor email
    if (this.currentUser && this.currentUser.role === 'General Practitioner' && !this.newPatientId) {
      this.userService.getUser(this.currentUser.id).subscribe({
        next: (res) => {
          this.newPatientInformationForm
            .get('doctorMobilePhoneNumber')
            ?.setValue(res.phoneNumber)
        },
      });

      this.newPatientInformationForm
        .get('doctorEmailAddress')
        ?.setValue(this.currentUser.email);
    }
  }

  ngAfterViewInit() {
    this.fullscreenService.initializeFullscreenButtons();

    if (this.goalsFormComponent && !this.goalsForm) {
      this.initializeForms();
    }
  }
  
  getPatientRecordCaseDetail() {
    if (this.caseId) {
      this.consultationsService.getPatientRecordCaseDetail(this.caseId).subscribe({
        next: (res) => {
          if (!res) return;
          this.latestCaseDetail = res;
  
          // newPatientInformationForm
          this.newPatientInformationForm.patchValue({
            tckn: res.tckn,
            name: res.name,
            lastName: res.lastName,
            gender: res.gender == "Erkek" ? 1 : 2,
            birthDate: this.formatDateToDisplay(res.birthDate),
            email: res.email,
            phone1: res.phone,
            doctorMobilePhoneNumber: res.doctorMobilePhoneNumber,
            doctorEmailAddress: res.doctorEmailAddress,
            height: res.height,
            weight: res.weight,
            bmi: res.bmi,
          });
          this.setWarningPreferencesToForm(res.warningPreferences);
          // Hasta Yakınları (patientRelatives)
          const relativesFormArray = this.newPatientInformationForm.get('patientRelatives') as FormArray;
          relativesFormArray.clear(); // Öncekileri temizle
          (res.patientRelatives || []).forEach((relative: any) => {
            relativesFormArray.push(this.fb.group({
              nextOfKinEmailAddress: [relative.nextOfKinEmailAddress, [Validators.email]],
              nextOfKinMobilePhoneNumber: [relative.nextOfKinMobilePhoneNumber, [
                Validators.minLength(13),
                Validators.maxLength(13),
                Validators.pattern('^\\+?[0-9]{7,15}$'),
              ]]
            }));
          });
  
          // caseSettingForm
          this.caseSettingForm.patchValue({
            hypoglycemiaThreshold: res.caseSetting?.hypoglycemiaThreshold,
            fastingGlucoseThreshold: res.caseSetting?.fastingGlucoseThreshold,
            postprandialGlucoseThreshold: res.caseSetting?.postprandialGlucoseThreshold,
            hba1cThreshold: res.caseSetting?.hba1cThreshold,
            followUpDurationDays: res.caseSetting?.followUpDurationDays,
            disableNotificationsAfterFollowUp: res.caseSetting?.disableNotificationsAfterFollowUp,
          });
  
          // diseasesInformationForm
          const disease = res.diabetesCaseInformation;
          const chronic = disease?.chronicCondition || {};
          const lab = disease?.laboratoryInformation || {};
          const med = disease?.medicationType || {};
          const otherMeds = disease?.otherMedicationSchedules || [];
          try {
            this.diseasesInformationForm.patchValue({
              hasDiabetes: disease?.hasDiabetes,
              diabetesTypeId: disease?.diabetesType?.id,
              diagnosisDate: new Date(disease?.diagnosisDate).getFullYear(),
              diagnosisDateView: new Date(disease?.diagnosisDate).getFullYear(),
              medicationType: null, // bu alanın backend'de karşılığı yok gibi
              oralHypoglycemic: med.oralHypoglycemic,
              insulin: med.insulin,
              none: med.none,
    
              insulinAdministrationMethod: disease?.insulinAdministrationMethod,
    
              testDate:this.formatDateToDisplay(lab?.testDate) ,
              timeOfDay: lab?.testTime,
              hbA1cValue: lab?.hbA1CValue,
              targetLowerLimit: lab?.targetLowerLimit,
              targetUpperLimit: lab?.targetUpperLimit,
    
              hypertension: chronic.hypertension,
              cardiovascularDisease: chronic.cardiovascularDisease,
              heartFailure: chronic.heartFailure,
              hyperlipidemia: chronic.hyperlipidemia,
              kidneyFailure: chronic.kidneyFailure,
              chronicPain: chronic.chronicPain,
              majorDepression: chronic.majorDepression,
              anxiety: chronic.anxiety,
              sleepDisorder: chronic.sleepDisorder,
              physicalDisability: chronic.physicalDisability,
              other: chronic.other,
            });
            this.ch.detectChanges();
          } catch (error) {
            console.error('Error patching diseasesInformationForm:', error);
          }

          this.patchMedicationSchedulesFromCase(disease);
          
  
          // Other medication schedule (sadece sabah-öğle-akşam varsayılan mapping)
          if (otherMeds.length > 0) {
            const morning = otherMeds.find((x) => x.timePeriod === 1);
            const noon = otherMeds.find((x) => x.timePeriod === 2);
            const evening = otherMeds.find((x) => x.timePeriod === 3);
            const other = otherMeds.find((x) => x.timePeriod === 4);
          
            if (morning) {
              this.diseasesInformationForm.patchValue({
                otherMed_morningSelected: true,
                otherMed_morningDose: morning.dosage,
                otherMed_morningTime: this.formatDate(morning.time),
                otherMed_morningName: morning.usedMedications?.[0]?.medicationId ?? null,
                otherMed_morningOtherMedication: morning.usedMedications?.[0]?.otherMedication,
              });
            }
          
            if (noon) {
              this.diseasesInformationForm.patchValue({
                otherMed_noonSelected: true,
                otherMed_noonDose: noon.dosage,
                otherMed_noonTime: this.formatDate(noon.time),
                otherMed_noonName: noon.usedMedications?.[0]?.medicationId ?? null,
                otherMed_noonOtherMedication: noon.usedMedications?.[0]?.otherMedication,
              });
            }
          
            if (evening) {
              this.diseasesInformationForm.patchValue({
                otherMed_eveningSelected: true,
                otherMed_eveningDose: evening.dosage,
                otherMed_eveningTime: this.formatDate(evening.time),
                otherMed_eveningName: evening.usedMedications?.[0]?.medicationId ?? null,
                otherMed_eveningOtherMedication: evening.usedMedications?.[0]?.otherMedication,
              });
            }
          
            if (other) {
              this.diseasesInformationForm.patchValue({
                otherMed_otherSelected: true,
                otherMed_otherDose: other.dosage,
                otherMed_otherTime: this.formatDate(other.time),
                otherMed_otherName: other.usedMedications?.[0]?.medicationId ?? null,
                otherMed_otherOtherMedication: other.usedMedications?.[0]?.otherMedication,
              });
            }
          }
          
  
          // habitsForm verisi response'da bulunmuyor, varsa ayrı maplenebilir
  
          // Loglama
          console.log("Tüm form verileri başarıyla set edildi");
        },
      });
    }
  }
  

  private setWarningPreferencesToForm(warningPreferences: any[]) {
    if (!warningPreferences || !Array.isArray(warningPreferences)) return;
  
    const warningPreferencesMap = {
      [WarningPreferenceType.HypoglycemiaAlert]: 'lowBloodSugar',
      [WarningPreferenceType.GlucoseMeasurementMissed]: 'noGlucoseMeasurement',
      [WarningPreferenceType.SurveyDataMissing]: 'noSurveyData',
    };
  
    for (const pref of warningPreferences) {
      const typeKey = warningPreferencesMap[pref.warningPreferenceType];
      if (!typeKey) continue;
  
      this.newPatientInformationForm.patchValue({
        [`notification_${typeKey}_doctorSms`]: pref.doctorSms,
        [`notification_${typeKey}_doctorEmail`]: pref.doctorEmail,
        [`notification_${typeKey}_nextOfKinSms`]: pref.nextOfKinSms,
        [`notification_${typeKey}_nextOfKinEmail`]: pref.nextOfKinEmail,
      });
    }
  }
  
  formatDateToDisplay(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
  formatDate(time:any){
    const formattedTime = time?.substring(0, 5);
    return formattedTime;
  }
  getMedicalInformationsList(): void {
    this.consultationsService
      .getDiabetesPreparationPageInformations()
      .subscribe((res) => {
        this.insulinTypes = res?.insulinTypes;
        this.omedicationTypes = res?.medications;
        if (this.latestCaseDetail?.diabetesCaseInformation) {
          this.patchMedicationSchedulesFromCase(
            this.latestCaseDetail.diabetesCaseInformation
          );
        }
      });
  }

  private patchMedicationSchedulesFromCase(disease: any) {
    if (!disease) return;

    const periodToPrefix: Record<number, string> = {
      1: 'morning',
      2: 'noon',
      3: 'evening',
    };

    const oralSchedules = Array.isArray(disease.oralMedicationSchedules)
      ? disease.oralMedicationSchedules
      : [];
    oralSchedules.forEach((s: any) => {
      const prefix = periodToPrefix[s?.timePeriod];
      if (!prefix) return;

      this.diseasesInformationForm.patchValue({
        [`${prefix}OralHypoglycemicSelected`]: s?.selected ?? true,
        [`${prefix}OralHypoglycemicMedicineName`]:
          s?.medicineName ?? s?.medicationId ?? null,
        [`${prefix}OralHypoglycemicDose`]: s?.dosage ?? null,
        [`${prefix}OralHypoglycemicTime`]: this.formatDate(s?.time),
      });
    });

    const insulinSchedules = Array.isArray(disease.insulinMedicationSchedules)
      ? disease.insulinMedicationSchedules
      : [];
    insulinSchedules.forEach((s: any) => {
      const prefix = periodToPrefix[s?.timePeriod];
      if (!prefix) return;

      const rawTypes: any[] = Array.isArray(s?.insulinTypes) ? s.insulinTypes : [];
      const typeIds = rawTypes
        .map((t) => (typeof t === 'string' ? t : t?.id))
        .filter(Boolean);
      const typeNames = rawTypes
        .map((t) => (typeof t === 'string' ? '' : (t?.name ?? '')))
        .filter(Boolean)
        .map((n) => String(n).toLowerCase());

      const byId = (idx: number) => {
        const id = this.insulinTypes?.[idx]?.id;
        return id ? typeIds.includes(id) : false;
      };
      const byName = (needle: string) =>
        typeNames.some((n) => n.includes(needle));

      this.diseasesInformationForm.patchValue({
        [`${prefix}InsulinSelected`]: s?.selected ?? true,
        [`${prefix}InsulinDose`]: s?.dosage ?? null,
        [`${prefix}InsulinTime`]: this.formatDate(s?.time),
        [`${prefix}InsulinNPH`]: byId(0) || byName('nph'),
        [`${prefix}InsulinLente`]: byId(1) || byName('lente'),
        [`${prefix}InsulinUltralente`]: byId(2) || byName('ultralente'),
      });
    });
  }

  getPatientCaseCardInformation(): void {
    if (this.newPatientId) {
      this.consultationsService
        .getPatientCaseCardInformation(this.newPatientId)
        .subscribe((res: PatientInformationCard) => {
          console.log('Patient Case Card Information:', res);
          const sortedRelatives = (res.patientRelatives || []).sort((a, b) => {
            const aFilled = Object.values(a).some(value => value !== null && value !== '');
            const bFilled = Object.values(b).some(value => value !== null && value !== '');
            return Number(bFilled) - Number(aFilled); // dolular başa gelsin
          });

          this.newPatientInformationForm.patchValue({
            tckn: res.tckn,
            name: res.name,
            lastName: res.lastName,
            gender: res.gender,
            birthDate: DateFormatterUtil.formatDate(res.birthDate),
            email: res.email,
            phone1: res.phone1,
            height: res.height,
            weight: res.weight,
            patientRelatives: sortedRelatives,
            doctorMobilePhoneNumber:
              res.doctorMobilePhoneNumber,
            doctorEmailAddress: res.doctorEmailAddress,
          });
        });
    }
  }

  onBMICalculated(bmi: number) {
    this.bmi = bmi;
  }

  checkDisabledTab(type: string): string {
    switch (type) {
      case 'diseases-information':
        return !this.newPatientInformationForm.valid ? 'disabledTab' : '';
      case 'habits':
        return !this.diseasesInformationForm.valid ? 'disabledTab' : '';
      case 'goals':
        return !this.habitsForm.valid ? 'disabledTab' : '';
      case 'case-setting':
        return !this.goalsForm.valid ? 'disabledTab' : '';
      case 'summary':
        return !this.caseSettingForm.valid ? 'disabledTab' : '';  
    }
    return '';
  }

  goToOtherTab(type: string) {
    const tabLinks = document.querySelectorAll('.nav-link');
    const tabPanes = document.querySelectorAll('.tab-pane');
    let isValid: boolean = false;

    switch (type) {
      case 'diseases-information':
        isValid = this.newPatientInformationForm.valid;
        break;
      case 'habits':
        isValid = this.diseasesInformationForm.valid;
        break;
      case 'goals':
        isValid = this.habitsForm.valid;
        break;
      case 'case-setting':
        isValid = this.goalsForm.valid;
        break;
      case 'summary':
        isValid =  this.caseSettingForm.valid;
        break;    
    }

    if (isValid) {
      tabLinks.forEach((link) => link.classList.remove('active'));
      tabPanes.forEach((pane) => pane.classList.remove('show', 'active'));
      const tabLink = document.querySelector(`[href="#${type}"]`);
      const tabPane = document.querySelector(`#${type}`);

      if (tabLink && tabPane) {
        tabLink.classList.add('active');
        tabPane.classList.add('show', 'active');
      }
    } else {
      if (type === 'diseases-information') {
        this.newPatientInformationForm.markAllAsTouched();
      } else if (type === 'habits') {
        this.diseasesInformationForm.markAllAsTouched();
      } else if (type === 'goals') {
        this.habitsForm.markAllAsTouched();
      } else if (type === 'case-setting') {
        this.goalsForm.markAllAsTouched();
      }
    }
  }

  isPreparationSaveBtnEnabled(): boolean {
    return (
      this.newPatientInformationForm.valid &&
      this.habitsForm.valid &&
      this.goalsForm.valid &&
      this.diseasesInformationForm.valid && 
      this.caseSettingForm.valid
    );
  }

  getFormattedNewPatientInformationForm() {

    const warningPreferencesMap = {
      lowBloodSugar: WarningPreferenceType.HypoglycemiaAlert,
      noGlucoseMeasurement: WarningPreferenceType.GlucoseMeasurementMissed,
      noSurveyData: WarningPreferenceType.SurveyDataMissing,
    };
    var notificationTypes: { id: string; label: string }[] = [
      { id: 'lowBloodSugar', label: this.translate.instant('lowBloodSugar') },
      {
        id: 'noGlucoseMeasurement',
        label: this.translate.instant('noGlucoseMeasurement'),
      },
      {
        id: 'noSurveyData',
        label: this.translate.instant('noSurveyData'),
      },
    ];

    const warningPreferences = notificationTypes.map((type) => {
      const getValue = (methodId: string) =>
        this.newPatientInformationForm.get(`notification_${type.id}_${methodId}`)?.value === true;

      return {
        warningPreferenceType: warningPreferencesMap[type.id],
        doctorSms: getValue('doctorSms'),
        doctorEmail: getValue('doctorEmail'),
        nextOfKinSms: getValue('nextOfKinSms'),
        nextOfKinEmail: getValue('nextOfKinEmail'),
      };
    });

    // Case Preparation
    if (this.newPatientId) {
      this.newPatientInformationForm.value.gender =
        +this.newPatientInformationForm.value.gender;
      this.newPatientInformationForm.value.birthDate = this.formatBirthDate(
        this.newPatientInformationForm.value.birthDate
      );

      delete this.newPatientInformationForm.value.tckn;
      delete this.newPatientInformationForm.value.name;
      delete this.newPatientInformationForm.value.lastName;
      delete this.newPatientInformationForm.value.gender;
      delete this.newPatientInformationForm.value.birthDate;
      delete this.newPatientInformationForm.value.email;
      delete this.newPatientInformationForm.value.phone1;
      delete this.newPatientInformationForm.value.doctorMobilePhoneNumber;
      delete this.newPatientInformationForm.value.doctorEmailAddress;
      delete this.newPatientInformationForm.value.height;
      delete this.newPatientInformationForm.value.weight;
     

      // FormArray olan nextOfKins'i temizle
      const nextOfKinsArray = this.newPatientInformationForm.get('nextOfKins') as FormArray;
      if (nextOfKinsArray) {
        nextOfKinsArray.clear(); // tüm yakını temizle
      }

      const formattedNewPatientInformationForm = {
        ...this.newPatientInformationForm.value,
        customerCode: this.currentUser.customerCode,
        warningPreferences: warningPreferences,
        bmi: this.bmi,
      };
      Object.keys(formattedNewPatientInformationForm)
      .filter(key => key.startsWith('notification_'))
      .forEach(key => delete formattedNewPatientInformationForm[key]);
      delete formattedNewPatientInformationForm.notification_lowBloodSugar;
      delete formattedNewPatientInformationForm.notification_noGlucoseMeasurement;
      delete formattedNewPatientInformationForm.notification_noSurveyData;
      delete formattedNewPatientInformationForm.ecgFile;
      delete formattedNewPatientInformationForm.bmi;
      delete formattedNewPatientInformationForm.customerCode;

      return formattedNewPatientInformationForm;
    }
    // Patient Preparation
    else {
      this.newPatientInformationForm.value.gender =
        +this.newPatientInformationForm.value.gender;
      this.newPatientInformationForm.value.birthDate = this.formatBirthDate(
        this.newPatientInformationForm.value.birthDate
      );

      const formattedNewPatientInformationForm = {
        ...this.newPatientInformationForm.value,
        customerCode: this.currentUser.customerCode,
        warningPreferences: warningPreferences,
        bmi: this.bmi,
      };
      Object.keys(formattedNewPatientInformationForm)
      .filter(key => key.startsWith('notification_'))
      .forEach(key => delete formattedNewPatientInformationForm[key]);
      delete formattedNewPatientInformationForm.notification_lowBloodSugar;
      delete formattedNewPatientInformationForm.notification_noGlucoseMeasurement;
      delete formattedNewPatientInformationForm.notification_noSurveyData;
      delete formattedNewPatientInformationForm.ecgFile;
      return formattedNewPatientInformationForm;
    }
  }

  getFormattedHabitsForm() {
    if (!this.habitsSurvey) {
      return [];
    }

    const formattedHabitsForm = [];

    const controlQuestionMap: { [key: string]: string } = {
      healthyEating: this.getQuestionIdByOrder(this.habitsSurvey, 1),
      takeMedications: this.getQuestionIdByOrder(this.habitsSurvey, 2),
      monitorDisease: this.getQuestionIdByOrder(this.habitsSurvey, 3),
      active: this.getQuestionIdByOrder(this.habitsSurvey, 4),
      stressLevel: this.getQuestionIdByOrder(this.habitsSurvey, 5),
      hypoglycemicAttacks: this.getQuestionIdByOrder(this.habitsSurvey, 6),
      lowSodium: this.getQuestionIdByOrder(this.habitsSurvey, 7),
      exercise: this.getQuestionIdByOrder(this.habitsSurvey, 8),
      exerciseDuration: this.getQuestionIdByOrder(this.habitsSurvey, 9),
    };

    for (const [controlName, questionId] of Object.entries(
      controlQuestionMap
    )) {
      const value = this.habitsForm.value[controlName];

      if (value !== null && value !== undefined && questionId) {
        const question = this.getQuestionById(this.habitsSurvey, questionId);
        const isMultipleChoiceQuestion = question?.answerType === 1;

        formattedHabitsForm.push({
          surveyId: this.habitsSurvey.id,
          questionId: questionId,
          answer: isMultipleChoiceQuestion
            ? this.getScoreFromId(question, value)
            : +value,
          answerOptionId: isMultipleChoiceQuestion ? value : null,
        });
      }
    }

    return formattedHabitsForm;
  }

  getScoreFromId(
    question: SurveyQuestion | undefined,
    optionId: string
  ): number {
    if (!question || !question.answerOptions) {
      return 0;
    }

    const option = question.answerOptions.find((opt) => opt.id === optionId);
    // return option ? option.score : 0;
    return option ? null : 0;
  }

  getQuestionIdByOrder(survey: Survey | null, order: number): string {
    if (!survey) return '';
    const question = survey.questions.find((q) => q.order === order);
    return question ? question.id : '';
  }

  getQuestionById(
    survey: Survey | null,
    questionId: string
  ): SurveyQuestion | undefined {
    if (!survey) return undefined;
    return survey.questions.find((q) => q.id === questionId);
  }

  initializeForms() {
    const goalsControls: { [key: string]: any } = {};

    if (this.goalsFormComponent) {
      this.goalsFormComponent.goalQuestions.forEach((goal) => {
        goalsControls[goal.controlName] = [null, Validators.required];
      });
    } else {
      const defaultGoalControls = [
        'healthyEatingGoal',
        'medicationUsageGoal',
        'checkupsGoal',
        'exerciseGoal',
        'saltUsageGoal',
        'stressReductionGoal',
      ];

      defaultGoalControls.forEach((controlName) => {
        goalsControls[controlName] = [null, Validators.required];
      });
    }

    this.goalsForm = this.fb.group(goalsControls);
  }

  getFormattedGoalsForm() {
    if (!this.goalsSurvey) {
      return [];
    }

    const formattedGoalsForm = [];

    const controlOrder = {
      healthyEatingGoal: 1,
      medicationUsageGoal: 2,
      checkupsGoal: 3,
      exerciseGoal: 4,
      saltUsageGoal: 5,
      stressReductionGoal: 6,
    };

    for (const [controlName, order] of Object.entries(controlOrder)) {
      const value = this.goalsForm.value[controlName];
      const questionId = this.getQuestionIdByOrder(this.goalsSurvey, order);

      if (value !== null && value !== undefined && questionId) {
        formattedGoalsForm.push({
          surveyId: this.goalsSurvey.id,
          questionId: questionId,
          answer: +value,
          answerOptionId: null,
        });
      }
    }

    return formattedGoalsForm;
  }

  getFormattedDiseasesInformationForm() {
    const formValues = this.diseasesInformationForm.value;
    const formattedTestDate = this.formatBirthDate(formValues.testDate);
    const formattedDiagnosisDate = this.formatBirthDate(
      formValues.diagnosisDate
    );
    const formattedTestTime = this.formatTime(formValues.timeOfDay);

    const getOralMedicationSchedule = (period: TimePeriod) => {
      const periodMap = {
        [TimePeriod.Morning]: 'morning',
        [TimePeriod.Noon]: 'noon',
        [TimePeriod.Evening]: 'evening',
      };

      const prefix = periodMap[period];

      return {
        timePeriod: period,
        selected: formValues[`${prefix}OralHypoglycemicSelected`],
        medicineName: formValues[`${prefix}OralHypoglycemicMedicineName`],
        dosage: formValues[`${prefix}OralHypoglycemicDose`] ?? 0,
        time: this.formatTime(formValues[`${prefix}OralHypoglycemicTime`]),
      };
    };

    const getInsulinMedicationSchedule = (period: TimePeriod) => {
      const periodMap = {
        [TimePeriod.Morning]: 'morning',
        [TimePeriod.Noon]: 'noon',
        [TimePeriod.Evening]: 'evening',
      };

      const prefix = periodMap[period];

      return {
        timePeriod: period,
        selected: formValues[`${prefix}InsulinSelected`],
        insulinTypes: this.getSelectedInsulinTypeIds(
          formValues[`${prefix}InsulinNPH`],
          formValues[`${prefix}InsulinLente`],
          formValues[`${prefix}InsulinUltralente`]
        ),
        dosage: formValues[`${prefix}InsulinDose`] ?? 0,
        time: this.formatTime(formValues[`${prefix}InsulinTime`]),
      };
    };

    const getOtherMedicationSchedule = (period: TimePeriod) => {
      const periodMap = {
        [TimePeriod.Morning]: 'morning',
        [TimePeriod.Noon]: 'noon',
        [TimePeriod.Evening]: 'evening',
        [TimePeriod.Other]: 'other',
      };

      const prefix = periodMap[period];

      return {
        timePeriod: period,
        dosage: formValues[`otherMed_${prefix}Dose`] ?? 0,
        time: this.formatTime(formValues[`otherMed_${prefix}Time`]),
        usedMedications: [
          {
            medicationId:
              formValues[`otherMed_${prefix}Name`] === OTHER_MEDICATIONS_OTHERS
                ? null
                : formValues[`otherMed_${prefix}Name`],
            otherMedication:
              formValues[`otherMed_${prefix}Name`] === OTHER_MEDICATIONS_OTHERS
                ? formValues[`otherMed_${prefix}OtherMedication`]
                : null,
          },
        ],
      };
    };

    const oralMedicationSchedules = formValues.oralHypoglycemic
      ? [
        getOralMedicationSchedule(TimePeriod.Morning),
        getOralMedicationSchedule(TimePeriod.Noon),
        getOralMedicationSchedule(TimePeriod.Evening),
      ]
      : [];

    const insulinMedicationSchedules = formValues.insulin
      ? [
        getInsulinMedicationSchedule(TimePeriod.Morning),
        getInsulinMedicationSchedule(TimePeriod.Noon),
        getInsulinMedicationSchedule(TimePeriod.Evening),
      ]
      : [];

    const form = {
      hasDiabetes: formValues.hasDiabetes,
      diabetesTypeId: formValues.diabetesTypeId,
      diagnosisDate: formattedDiagnosisDate,
      medicationType: {
        oralHypoglycemic: formValues.oralHypoglycemic,
        insulin: formValues.insulin,
        none: formValues.none,
      },
      oralMedicationSchedules,
      insulinAdministrationMethod: formValues.insulin
        ? formValues.insulinAdministrationMethod
        : null,
      insulinMedicationSchedules,
      laboratoryInformation: {
        testDate: formattedTestDate,
        testTime: formattedTestTime,
        hbA1CValue: formValues.hbA1cValue ?? 0,
        targetLowerLimit: formValues.targetLowerLimit ?? 0,
        targetUpperLimit: formValues.targetUpperLimit ?? 0,
      },
      chronicCondition: {
        hypertension: formValues.hypertension,
        cardiovascularDisease: formValues.cardiovascularDisease,
        heartFailure: formValues.heartFailure,
        hyperlipidemia: formValues.hyperlipidemia,
        kidneyFailure: formValues.kidneyFailure,
        chronicPain: formValues.chronicPain,
        majorDepression: formValues.majorDepression,
        anxiety: formValues.anxiety,
        sleepDisorder: formValues.sleepDisorder,
        physicalDisability: formValues.physicalDisability,
        other: formValues.other,
      },
      otherMedicationSchedules: [
        getOtherMedicationSchedule(TimePeriod.Morning),
        getOtherMedicationSchedule(TimePeriod.Noon),
        getOtherMedicationSchedule(TimePeriod.Evening),
      ],
    };

    return form;
  }

  savePreparation() {
    if (this.isPreparationSaveBtnEnabled) {
      const formattedNewPatientInformationForm =
        this.getFormattedNewPatientInformationForm();

      const filteredPatientRelatives = (formattedNewPatientInformationForm.patientRelatives || []).filter(rel => {
        return rel.nextOfKinEmailAddress?.trim() !== '' && rel.nextOfKinMobilePhoneNumber?.trim() !== '';
      });
      const formattedHabitsForm = this.getFormattedHabitsForm();
      const formattedGoalsForm = this.getFormattedGoalsForm();
      const formattedDiseasesInformationForm =
        this.getFormattedDiseasesInformationForm();
      const caseSetting = this.caseSettingForm.value;  

      const formData = {
        ...formattedNewPatientInformationForm,
        patientRelatives: filteredPatientRelatives,
        answers: [...formattedHabitsForm, ...formattedGoalsForm],
        ...formattedDiseasesInformationForm,
        caseSetting: caseSetting
      };

      this.overlayService.show();

      // Case Preparation
      if (this.newPatientId) {
        formData.patientId = this.newPatientId;
        this.patientsService
          .createDiabetesPatientRecordCase(formData)
          .subscribe({
            next: (res) => {
              if (this.uploadedFile && res) {
                this.uploadECGFile(res.id);
              } else {
                this.toastService.showToast(
                  this.translate.instant('saveSuccessfully'),
                  'success'
                );

                setTimeout(() => {
                  this.overlayService.hide();
                  this.router.navigate(['/consultation/list']);
                }, 1000);
              }
            },
            error: () => {
              this.overlayService.hide();
            },
          });
      }
      // Patient Preparation
      else {
        this.patientsService.createDiabetesPatientRecord(formData).subscribe({
          next: (res) => {
            if (this.uploadedFile && res) {
              this.uploadECGFile(res.patientCaseId);
            } else {
              this.toastService.showToast(
                this.translate.instant('saveSuccessfully'),
                'success'
              );

              setTimeout(() => {
                this.overlayService.hide();
                this.router.navigate(['/patient/list']);
              }, 1000);
            }
          },
          error: () => {
            this.overlayService.hide();
          },
        });
      }
    } else {
      this.toastService.showToast('pleaseFillAllFields', 'warning');
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleECGFile(files[0]);
    }
  }

  onECGFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file) {
      const fileName = file.name.toLowerCase();
      if (fileName.endsWith('.ecg')) {
        this.isUploading = true;
        if (input.files && input.files.length > 0) {
          this.handleECGFile(input.files[0]);
        }
      }
    }
  }

  handleECGFile(file: File) {
    const reader = new FileReader();
    this.uploadFileName = file?.name;
    reader.onload = () => {
      this.uploadedFile = reader.result;
    };
    reader.readAsDataURL(file);
  }

  onDragDropAreaClick() {
    this.fileInput.nativeElement.click();
  }

  clearForm(): void { }

  isControlInvalid(controlName: string): boolean {
    const control = this.newPatientInformationForm.get(controlName);
    return control ? control.invalid && control.touched : false;
  }

  preventForbiddenCharacters(event: Event, type: string): void {
    const inputElement = event.target as HTMLInputElement;
    let val: string | number = inputElement.value;

    if (type === 'number') {
      val = Number(inputElement.value);
      if (isNaN(val) || val < 1) {
        inputElement.value = '';
        return;
      }
    } else if (type === 'text') {
      if (/^[\s]|[^a-zA-ZğüşıöçĞÜŞİÖÇ\s]/.test(val)) {
        inputElement.value = val.replace(/^[\s]+|[^a-zA-ZğüşıöçĞÜŞİÖÇ\s]/g, '');
      }
      if (inputElement.value.trim() === '') {
        inputElement.value = '';
      }
    } else if (type === 'email') {
      if (/^[\s]|[^a-zA-Z0-9@._]/.test(val)) {
        inputElement.value = val.replace(/^[\s]+|[^a-zA-Z0-9@._]/g, '');
      }
      if (inputElement.value.trim() === '') {
        inputElement.value = '';
      }
    }
  }

  onEcgFileUploaded(event: {
    fileData: string | ArrayBuffer | null;
    fileName: string;
  }) {
    this.uploadedFile = event.fileData;
    this.uploadFileName = event.fileName;
    this.isUploading = false;
  }

  uploadECGFile(patientRecordCaseId: string) {
    if (!this.uploadedFile) {
      this.toastService.showToast(
        this.translate.instant('ecgFileMissing'),
        'error'
      );
      return;
    }

    const formData = new FormData();

    if (typeof this.uploadedFile === 'string') {
      const base64Data = this.uploadedFile.split(',')[1];
      const blob = this.dataURItoBlob(base64Data);
      formData.append('ECGFile', blob, this.uploadFileName || 'ecg_file.ecg');
    } else if (
      this.fileInput &&
      this.fileInput.nativeElement &&
      this.fileInput.nativeElement.files &&
      this.fileInput.nativeElement.files.length > 0
    ) {
      const file = this.fileInput.nativeElement.files[0];
      formData.append('ECGFile', file);
    }

    formData.append('PatientRecordCaseId', patientRecordCaseId);

    this.consultationsService.uploadEcgFile(formData).subscribe({
      next: (res) => {
        this.toastService.showToast(
          this.translate.instant('saveSuccessfully'),
          'success'
        );

        setTimeout(() => {
          this.overlayService.hide();
          this.router.navigate(['/patient/list']);
        }, 1000);
        return res;
      },
      error: () => {
        this.toastService.showToast(
          this.translate.instant('somethingWentWrong'),
          'error'
        );
        this.overlayService.hide();
      },
    });
  }

  dataURItoBlob(dataURI: string): Blob {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }

    return new Blob([int8Array], { type: 'application/octet-stream' });
  }

  formatBirthDate(dateString: string): string {
    const datePattern = /^\d{2}-\d{2}-\d{4}$/;

    if (!datePattern.test(dateString)) {
      return dateString;
    }

    const [day, month, year] = dateString.split('-').map(Number);

    if (month < 1 || month > 12) {
      return dateString;
    }

    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
      return dateString;
    }

    const date = new Date(Date.UTC(year, month - 1, day));

    return date.toISOString();
  }

  formatTime(timeString: string): string {
    if (!timeString) {
      return '00:00:00';
    }
    return timeString + ':00';
  }

  loadSurveys() {
    this.surveyService.getPreparationPageSurveys().subscribe({
      next: (res) => {
        this.surveys = res;
        this.habitsSurvey =
          this.surveys.find((s) => s.id === SURVEY_TYPES.HABITS) || null;
        this.goalsSurvey =
          this.surveys.find((s) => s.id === SURVEY_TYPES.GOALS) || null;
      },
    });
  }

  getSelectedInsulinTypeIds(
    isNPH: boolean,
    isLente: boolean,
    isUltralente: boolean
  ): string[] {
    const selectedIds: string[] = [];

    if (isNPH) {
      selectedIds.push(this.insulinTypes[0].id); // NPH id
    }

    if (isLente) {
      selectedIds.push(this.insulinTypes[1].id); // Lente id
    }

    if (isUltralente) {
      selectedIds.push(this.insulinTypes[2].id); // Ultralente id
    }

    return selectedIds;
  }
}
